import config from 'react-global-configuration';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '@uncinc/react-drupal-core';

export const checkEmailExists = (email) => {
  return (dispatch) => {
    dispatch(setOperationStatus('checkEmail', 'fetch', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');

    return fetch(`${API_URL}/api/moodle/check-email`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((data) => {
        dispatch(setOperationStatus('checkEmail', 'fetch', UI_OPERATION_STATUS_SUCCESS));
        return data;
      })
      .catch((error) => {
        dispatch(setOperationStatus('checkEmail', 'fetch', UI_OPERATION_STATUS_ERROR));
        throw error;
      });
  };
};
